<template>
  <div :class="$style.publication">
    <div :class="$style.publicationWrapper">
      <div :class="$style.publicationForm">
        <div :class="[$style.field, {[$style.prompt]: wrongFieldList.title}]"><input ref="title" v-model="publication.title" placeholder="Название приложения"></div>
        <div :class="[$style.field, {[$style.prompt]: wrongFieldList.name}]"><input ref="name" v-model="publication.name" placeholder="Имя"></div>
          <div :class="[$style.field, {[$style.prompt]: wrongFieldList.surname}]"><input ref="surname" v-model="publication.surname" placeholder="Фамилия"></div>
        <v-select label="title"
                  value="Выберите"
                  :options="interestsList"
                  :searchable="false"
                  :clearable="false"
                  :class="$style.select"
                  v-model="publication.section">
        </v-select>
        <div :class="[$style.field, {[$style.prompt]: wrongFieldList.description}]"><textarea ref="description" v-model="publication.description" placeholder="Описание функционала"/></div>
      </div>
      <div :class="$style.publicationResult">
        <div :class="$style.app">
          <img src="@/assets/lesson4/publication.svg" :class="$style.img" alt="next">
          <span>{{publication.title}}</span>
          <span>{{publication.name}} {{publication.surname}}</span>
        </div>
      </div>
    </div>
    <Button :disabled="disabled" @click="submit">Опубликовать</Button>
  </div>
</template>

<script>
import Button from '../../../../components/Button/Button'

export default {
  name: 'publicationForm',
  components: { Button },
  props: {
    interestsList: Array,
  },
  data() {
    return {
      publication: {
        title: '', name: '', surname: '', section: { title: 'Выберите категорию', field: '' }, description: '',
      },
      wrongFieldList: {
        title: null, name: null, surname: null, description: null,
      },
      disabled: true,
    }
  },
  watch: {
    publication: {
      deep: true,
      handler(val) {
        Object.keys(val).forEach((key) => {
          if (val[key]) {
            this.testField(key, val[key])
          } else this.wrongFieldList[key] = false
        })
        this.disabled = !(this.publication.title && this.publication.name && this.publication.section.field && this.publication.description && Object.values(this.wrongFieldList).every(item => item === false))
      },
    },
  },
  methods: {
    testField(key, str) {
      const regexp = new RegExp('\\w{0,5}[хx]([хx\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[уy*]([уy*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[ёiлeеюийя]\\w{0,7}|\\w{0,6}[пp]([пp\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[iие*]([iие*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[3зс*]([3зс*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[дd*]\\w{0,10}|[сcs][уy*]([уy*\\!@#\\$%\\^&*+-\\|\\/]{0,6})[4чkк*]\\w{1,3}|\\w{0,4}[bб]([bб\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[lл*]([lл*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[yя*]\\w{0,10}|\\w{0,8}[её][bб*][лске@eыиаa*][наи@йвл*]\\w{0,8}|\\w{0,4}[еe]([еe\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[бb*]([бb*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[uу*]([uу*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[н4ч*]\\w{0,4}|\\w{0,4}[еeё]([еeё\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[бb*]([бb*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[нn*]([нn*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[уy*]\\w{0,4}|\\w{0,4}[еe]([еe\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[бb*]([бb*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[оoаa@*]([оoаa@*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[тnнt*]\\w{0,4}|\\w{0,10}[ё]([ё\\!@#\\$%\\^&*+-\\|\\/]{0,6})[б*]\\w{0,6}|\\w{0,4}[pп]([pп\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[иeеi*]([иeеi*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[дd*]([дd*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[oоаa@еeиi*]([oоаa@еeиi*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[рr*]\\w{0,12}|\\w{0,6}[cсs][уu*][kк*][aа]|\\w{0,6}[aа][cсs*][cсs]|\\w{0,6}[b][oо*][t*][t*][oо*][m]|\\w{0,6}[d][аa*][m*][n]|\\w{0,6}[s]([s\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[h*]([h*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[i*]([i*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[t]([t\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})|\\w{0,6}[f]([f\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[u*]([u*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[сc*]([cс*\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})[k]([k\\s\\!@#\\$%\\^&*+-\\|\\/]{0,6})', 'g')
      const inputStr = str.toString().toLowerCase()
      const res = inputStr.match(regexp)
      let newStr = ''
      this.wrongFieldList[key] = false
      if (!res) return
      res.forEach((word) => {
        const newWord = word[0] + word.substr(1, word.length - 2).replaceAll(/./g, '*') + word[word.length - 1]
        newStr = inputStr.replaceAll(word, newWord)
      })
      this.wrongFieldList[key] = true
      this.publication[key] = newStr
    },
    submit() {
      if (this.publication.title && this.publication.name && this.publication.section.field && this.publication.description) {
        let wrong = false
        Object.keys(this.wrongFieldList).forEach((key) => {
          if (this.wrongFieldList[key]) {
            this.$refs[key].focus()
            wrong = true
          }
        })
        if (!wrong) this.$emit('closePublicationPopup', this.publication)
      } else this.$emit('showHelpBox')
    },
  },
}
</script>

<style lang="scss" module>
  .publication {
    width: 60%;
    min-height: 66rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: 4%;
    text-align: center;
    .publicationWrapper {
      display: flex;
      height: 80%;
      margin-bottom: 3rem;
    }
    .publicationForm {
      display: flex;
      width: 50%;
      padding: 4rem 0 1rem;
      flex-direction: column;
      justify-content: space-between;
      .select > div {
        height: 5.5rem;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 1.6rem;
        @media #{$m-mobile} {
          font-size: 2rem;
        }
      }
      @media #{$m-mobile} {
        width: 60%;
      }
    }
    .publicationResult {
      position: relative;
      width: 50%;
      @media #{$m-mobile} {
        width: 40%;
      }
    }
    button {
      width: 55%;
      @media #{$m-mobile} {
        height: 8rem;
        font-size: 3rem;
      }
    }
    .app {
      display: flex;
      position: absolute;
      left: 50%;
      top: 50%;
      height: max-content;
      width: 90%;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      font-size: 1.6rem;
      transform: translate(-50%, -50%);
      overflow: hidden;
      img {
        margin-bottom: 2rem;
        @media #{$m-mobile} {
          width: 14rem;
        }
      }
      span {
        margin-bottom: 1rem;
        line-height: 1.4;
      }
    }
    @media #{$m-mobile} {
      width: 98%;
    }
  }
  .select {
    display: inline-block;
    width: auto;
    font-size: 1.6rem;
    color: black;
    @media #{$m-mobile} {
      margin-bottom: 2rem;
    }
  }
  .field {
    text-align: left;
    & > input, textarea {
      width: 100%;
      height: 5.5rem;
      padding-left: 2rem;
      padding-right: 2rem;
      outline: none;
      border-radius: 1rem;
      border: 1px solid rgba(0, 0, 0, 0.1);
      font-size: 1.6rem;
      color: black;
      &::placeholder {
        color: black;
      }
      @media #{$m-mobile} {
        font-size: 2rem;
        box-shadow: none;
        -webkit-appearance: none;
      }
    }
    textarea {
      padding: 1.5rem 2rem;
      height: 12rem;
      resize: none;
    }
    @media #{$m-mobile} {
      margin-bottom: 3rem;
    }
  }
  .prompt {
    position: relative;
    &:after {
      content: "Некорректное слово";
      position: absolute;
      color: #FF003D;
      line-height: 1.4;
      width: 100%;
      height: 2rem;
      top: -2.5rem;
      left: 1rem;
      font-size: 1.6rem;
    }
    input, textarea {
      border-color: $color-pink;
    }
  }
</style>
